module.exports = function() {
  return new Worker(__webpack_public_path__ + "69799c175f2f82e347aa.worker.js");
};